import React from 'react';
import {useIntl} from 'react-intl';
import {useProjectTotals} from './ProjectScopingTotalsContext';
import {FlexRow, Text} from '@forecast-it/design-system';
import Util from '../../../../shared/util/util';

export const ActualHoursTooltip = () => {
	const intl = useIntl();
	const {totalsData} = useProjectTotals();

	return (
		<>
			<FlexRow justifyContent="space-between" gap="xxl">
				<Text size="2">{`${intl.formatMessage({id: 'project_scoping.tooltip_time_entries_on_task'})}:`}</Text>
				<Text size="2">{Util.convertMinutesToFullHour(totalsData.taskRegisteredMinutes, intl)}</Text>
			</FlexRow>
			<FlexRow justifyContent="space-between" gap="xxl">
				<Text size="2">{`${intl.formatMessage({id: 'project_scoping.tooltip_time_entries_on_project'})}:`}</Text>
				<Text size="2">{Util.convertMinutesToFullHour(totalsData.projectRegisteredMinutes, intl)}</Text>
			</FlexRow>
		</>
	);
};
